export default __webpack_public_path__ + "static/media/GreenCheck.c0c44fa0.svg";